import React, { useState } from 'react';
import { authAPI, tokenAPI } from '../services/api';
import './Login.css';

interface LoginProps {
  onLoginSuccess: () => void;
}

function Login({ onLoginSuccess }: LoginProps) {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [initialToken, setInitialToken] = useState<string | null>(null);

  React.useEffect(() => {
    const fetchInitialToken = async () => {
      try {
        const response = await tokenAPI.first();
        const data = response.data;
        const newToken = data?.token?.token;
        if (data?.created && newToken) {
          setInitialToken(newToken);
          setToken(newToken);
        }
      } catch {
        // intentional
      }
    };

    fetchInitialToken();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!token.trim()) {
      setError('Informe um token válido');
      setLoading(false);
      return;
    }

    const trimmedToken = token.trim();
    localStorage.setItem('access_token', trimmedToken);

    try {
      await authAPI.verify();
      onLoginSuccess();
    } catch (err) {
      localStorage.removeItem('access_token');
      setError('Token inválido. Verifique e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>🔐 FaceAPI</h1>
        <p className="login-subtitle">Acesse com seu Token de Integração</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="token">Token de Integração</label>
            <input
              id="token"
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="Cole seu token aqui"
              required
              autoFocus
            />
          </div>

          {error && (
            <div className="error-message">
              ❌ {error}
            </div>
          )}

          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        {initialToken && (
          <div className="login-hint" style={{ wordBreak: 'break-all' }}>
            ✅ Token inicial detectado:
            <br />
            <strong>{initialToken}</strong>
            <br />
            <button
              type="button"
              className="btn-login"
              style={{ marginTop: 10 }}
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(initialToken);
                } catch {
                }
              }}
            >
              📋 Copiar
            </button>
          </div>
        )}

      </div>
    </div>
  );
}

export default Login;
